import React from "react";
import Drawer from '@mui/material/Drawer';
import SideFilter from "../SideFilters/SideFilter";
import '../SideFilters/style/sidefilter.css'
import { FcEmptyFilter } from "react-icons/fc";
import CloseIcon from '@mui/icons-material/Close';
import { Button } from "@mui/material";

const TopbarFilter = ({filter,selectedFilters,setOpenAccordions,setSelectedFilters}) => {

    const [state, setState] = React.useState({
        right: false,
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };

    return (
        <div style={{ width: '100%', overflow: 'auto', height: '100%' }} className="topfilter">

          
            {['right'].map((anchor) => (
                <div key={anchor} >
                    <Button onClick={toggleDrawer(anchor, true)} className="text-black btn-filter"><FcEmptyFilter className="text-xl m-2"/> FILTER</Button>
                    <Drawer
                        anchor={anchor}
                        open={state[anchor]}
                        onClose={toggleDrawer(anchor, false)}
                    >
                        <div>
                            <CloseIcon onClick={toggleDrawer(anchor, false)} style={{margin:'15px'}}/>
                            <SideFilter filter={filter} selectedFilters={selectedFilters} setOpenAccordions={setOpenAccordions} setSelectedFilters={setSelectedFilters}/>
                        </div>
                    </Drawer>
                </div>
            ))}
          
         </div>
    )
}

export default TopbarFilter
